import domains from '@/config/domain';
import type { Domain } from '@/config/domain/type';


export const getDomainFromHost = (host: string): Domain => {
    let domainFound = domains.find(domain => {
        return domain.domain === host;
    });

    if (!domainFound) {
        domainFound = {
            domain: 'defaultDomain',
            website: 'http://www.trademarksonline.com.au',
            shortCode: 'default',
            title: 'Apply',
            name: 'Trademarks Online',
            description: 'apply',
            logo: '/img/TM-Logo-White-Thin.png',
            markSource: 'default',
            menuItems: [
                { label: 'Home', url: '' },
                { label: 'Pricing', url: '/pricing' },
                { label: 'FAQ', url: '/trademark-questions' },
                { label: 'About', url: '/about-us' },
            ],
            footerItems: [
                { label: 'Privacy Policy', url: '/privacy-policy' },
                { label: 'Terms of Use', url: '/terms-of-use' },
                { label: 'Contact Us', url: '/contact' },
            ],
            termOfUseUrl: '/terms-of-use',
            bannerImageUrl: '',
            gtmId: 'GTM-57R6JNG9',
        };
    }

    return domainFound;
};
